export default {
    /**URL BASE DEL CORE */
    APP_CORE_URL: process.env.VUE_APP_CORE_URL_API
}